module.exports = __webpack_public_path__ + "static/media/redSkirt.49bf2c08.jpg";